var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.products.length
    ? _c("div", { staticClass: "profiles" }, [
        _c("p", { staticClass: "profiles__disclaimer" }, [
          _vm._v(
            "\n    You have pharmacy products in your cart which require some additional information:\n  "
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "profiles__products" },
          [
            _c("strong", [_vm._v("Products:")]),
            _vm._v(" "),
            _vm._l(_vm.products, function (product) {
              return _c("span", { key: product.key }, [
                _vm._v("\n      " + _vm._s(product.title) + "\n    "),
              ])
            }),
          ],
          2
        ),
        _vm._v(" "),
        _vm.$store.cID == null
          ? _c("div", { staticClass: "profiles__label-btn" }, [
              _c("label", { staticClass: "profile-label" }, [
                _vm._v(
                  "\n      You must be logged in with a profile to continue\n    "
                ),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "profiles__new-btn",
                  attrs: { href: "/account" },
                },
                [_vm._v("\n      Sign in\n    ")]
              ),
            ])
          : _c("div", { staticClass: "profiles__label-btn" }, [
              _c(
                "label",
                { staticClass: "profile-label", attrs: { for: "profile" } },
                [_vm._v("\n      Who is this product for?\n    ")]
              ),
              _vm._v(" "),
              _c("button", {
                staticClass: "profiles__new-btn",
                domProps: {
                  textContent: _vm._s(
                    _vm.showCreateNew ? "Cancel" : "Add new profile?"
                  ),
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.showCreateNew = !_vm.showCreateNew
                  },
                },
              }),
            ]),
        _vm._v(" "),
        _vm.profiles.length
          ? _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fullname,
                    expression: "fullname",
                  },
                ],
                staticClass: "profile-select",
                attrs: { id: "profile" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.fullname = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              _vm._l(_vm.profiles, function (profile, idx) {
                return _c(
                  "option",
                  { key: idx, domProps: { value: profile.fullname } },
                  [_vm._v("\n      " + _vm._s(profile.fullname) + "\n    ")]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "form",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showCreateNew,
                expression: "showCreateNew",
              },
            ],
            staticClass: "profiles__form",
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.createProfile()
              },
            },
          },
          [
            _c("h5", [_vm._v("New Profile")]),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "profile-label", attrs: { for: "fullname" } },
              [_vm._v("\n      Full Name*\n    ")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newProfile.fullname,
                  expression: "newProfile.fullname",
                },
              ],
              staticClass: "profile-input",
              attrs: { type: "text", id: "fullname", required: "" },
              domProps: { value: _vm.newProfile.fullname },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.newProfile, "fullname", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "profile-label", attrs: { for: "dob" } },
              [_vm._v("\n      Date of Birth (DD/MM/YYYY)*\n    ")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newProfile.dob,
                  expression: "newProfile.dob",
                },
              ],
              staticClass: "profile-input",
              attrs: { type: "text", id: "dob", required: "" },
              domProps: { value: _vm.newProfile.dob },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.newProfile, "dob", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "profile-label", attrs: { for: "gender" } },
              [_vm._v("\n      Gender*\n    ")]
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newProfile.gender,
                    expression: "newProfile.gender",
                  },
                ],
                staticClass: "profile-select",
                attrs: { id: "gender", required: "" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.newProfile,
                      "gender",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                },
              },
              [
                _c("option", { attrs: { value: "Male", selected: "" } }, [
                  _vm._v("\n        Male\n      "),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "Female" } }, [
                  _vm._v("\n        Female\n      "),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "Prefer not to say" } }, [
                  _vm._v("\n        Prefer not to say\n      "),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.newProfile.gender != "Male"
              ? _c("div", [
                  _c(
                    "label",
                    {
                      staticClass: "profile-label",
                      attrs: { for: "pregnant" },
                    },
                    [
                      _vm._v(
                        "\n        Is this patient pregnant or breastfeeding?\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newProfile.pregnant_or_breastfeeding,
                          expression: "newProfile.pregnant_or_breastfeeding",
                        },
                      ],
                      staticClass: "profile-select",
                      attrs: { id: "pregnant", required: "" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.newProfile,
                            "pregnant_or_breastfeeding",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "No", selected: "" } }, [
                        _vm._v("\n          No\n        "),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "Yes" } }, [
                        _vm._v("\n          Yes\n        "),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "profile-label", attrs: { for: "address" } },
              [_vm._v("\n      Address*\n    ")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newProfile.address,
                  expression: "newProfile.address",
                },
              ],
              staticClass: "profile-input",
              attrs: { type: "text", id: "address", required: "" },
              domProps: { value: _vm.newProfile.address },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.newProfile, "address", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "profile-label", attrs: { for: "phone" } },
              [_vm._v("\n      Phone*\n    ")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newProfile.phone,
                  expression: "newProfile.phone",
                },
              ],
              staticClass: "profile-input",
              attrs: { type: "text", id: "phone", required: "" },
              domProps: { value: _vm.newProfile.phone },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.newProfile, "phone", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "profile-label",
                attrs: { for: "patient_allergies" },
              },
              [_vm._v("\n      Patient Allergies (optional)\n    ")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newProfile.patient_allergies,
                  expression: "newProfile.patient_allergies",
                },
              ],
              staticClass: "profile-input",
              attrs: { type: "text", id: "patient_allergies" },
              domProps: { value: _vm.newProfile.patient_allergies },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.newProfile,
                    "patient_allergies",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "profile-label",
                attrs: { for: "patient_conditions" },
              },
              [_vm._v("\n      Patient Medical Conditions (optional)\n    ")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newProfile.patient_conditions,
                  expression: "newProfile.patient_conditions",
                },
              ],
              staticClass: "profile-input",
              attrs: { type: "text", id: "patient_conditions" },
              domProps: { value: _vm.newProfile.patient_conditions },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.newProfile,
                    "patient_conditions",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "profile-label",
                attrs: { for: "patient_medications" },
              },
              [_vm._v("\n      Patient Medications (optional)\n    ")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newProfile.patient_medications,
                  expression: "newProfile.patient_medications",
                },
              ],
              staticClass: "profile-input",
              attrs: { type: "text", id: "patient_medications" },
              domProps: { value: _vm.newProfile.patient_medications },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.newProfile,
                    "patient_medications",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "profiles__actions-btns" }, [
              _c("button", {
                staticClass: "btn",
                domProps: {
                  textContent: _vm._s(_vm.loading ? "Saving" : "Save"),
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--cancel",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.showCreateNew = false
                    },
                  },
                },
                [_vm._v("\n        Cancel\n      ")]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "profiles__checkbox-wrapper" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.confirmInfo,
                expression: "confirmInfo",
              },
            ],
            staticClass: "profile-checkbox",
            attrs: {
              type: "checkbox",
              id: "confirm-info",
              disabled: !_vm.selectedProfile,
              required: "",
            },
            domProps: {
              checked: Array.isArray(_vm.confirmInfo)
                ? _vm._i(_vm.confirmInfo, null) > -1
                : _vm.confirmInfo,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.confirmInfo,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.confirmInfo = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.confirmInfo = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.confirmInfo = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "profile-label", attrs: { for: "confirm-info" } },
            [
              _vm._v(
                "\n      I confirm the above medical information is correct.\n    "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "profiles__checkbox-wrapper" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.confirmPolicy,
                expression: "confirmPolicy",
              },
            ],
            staticClass: "profile-checkbox",
            attrs: {
              type: "checkbox",
              id: "confirm-policy",
              disabled: !_vm.selectedProfile,
              required: "",
            },
            domProps: {
              checked: Array.isArray(_vm.confirmPolicy)
                ? _vm._i(_vm.confirmPolicy, null) > -1
                : _vm.confirmPolicy,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.confirmPolicy,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.confirmPolicy = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.confirmPolicy = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.confirmPolicy = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _vm._m(0),
        ]),
        _vm._v(" "),
        _vm.selectedProfile
          ? _c(
              "div",
              { ref: "hidden", staticClass: "profiles__hidden-fields" },
              [
                _vm.selectedProfile.fullname
                  ? _c("input", {
                      attrs: { type: "hidden", name: "attributes[Name]" },
                      domProps: { value: _vm.selectedProfile.fullname },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedProfile.dob
                  ? _c("input", {
                      attrs: { type: "hidden", name: "attributes[DOB]" },
                      domProps: { value: _vm.selectedProfile.dob },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedProfile.gender
                  ? _c("input", {
                      attrs: { type: "hidden", name: "attributes[Gender]" },
                      domProps: { value: _vm.selectedProfile.gender },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedProfile.gender != "Male"
                  ? _c("input", {
                      attrs: {
                        type: "hidden",
                        name: "attributes[Pregnant Or Breastfeeding]",
                      },
                      domProps: {
                        value: _vm.selectedProfile.pregnant_or_breastfeeding,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedProfile.address
                  ? _c("input", {
                      attrs: { type: "hidden", name: "attributes[Address]" },
                      domProps: { value: _vm.selectedProfile.address },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedProfile.phone
                  ? _c("input", {
                      attrs: { type: "hidden", name: "attributes[Phone]" },
                      domProps: { value: _vm.selectedProfile.phone },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedProfile.patient_allergies
                  ? _c("input", {
                      attrs: { type: "hidden", name: "attributes[Allergies]" },
                      domProps: {
                        value: _vm.selectedProfile.patient_allergies,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedProfile.patient_conditions
                  ? _c("input", {
                      attrs: { type: "hidden", name: "attributes[Conditions]" },
                      domProps: {
                        value: _vm.selectedProfile.patient_conditions,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.selectedProfile.patient_medications
                  ? _c("input", {
                      attrs: {
                        type: "hidden",
                        name: "attributes[Medications]",
                      },
                      domProps: {
                        value: _vm.selectedProfile.patient_medications,
                      },
                    })
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "profile-label", attrs: { for: "confirm-policy" } },
      [
        _vm._v("\n      I agree to the Active Pharmacy "),
        _c("u", [_vm._v("privacy policy")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }